import { render } from "./invoices-app.vue?vue&type=template&id=2a386fbe"
import script from "./invoices-app.vue?vue&type=script&lang=js"
export * from "./invoices-app.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__